export type ReferralRewardStatus = 'completed' | 'current' | 'locked'

export type ReferralReward = {
  threshold: number
  label: string
  title: string
  description: string
}

export type ReferralCouponView = {
  code: string
  label: string
  planCode: string
  priceKopecks: number
}

export type ReferralTierView = {
  threshold: number
  title: string
  description: string
  reached: boolean
}

export type ReferralProgramState = {
  referralLink: string
  activeReferralsCount: number
  /** Permanent extra machines earned from referrals. */
  bonusSlots: number
  /** Consumable tracking credits balance (earned, not yet spent). */
  trackingCredits: number
  /** Unredeemed discount coupons. */
  coupons: ReferralCouponView[]
  /** Ladder rungs from the backend (falls back to the static list when empty). */
  tiers: ReferralTierView[]
}

/** No link until the server sends the user's own: a placeholder URL could be copied and sent to a colleague. */
export const REFERRAL_PROGRAM_LINK = ''

/** Human label for a rung, e.g. "1 коллега" / "5 коллег". */
export function tierLabel(threshold: number) {
  const lastTwo = threshold % 100
  const last = threshold % 10
  let word = 'коллег'
  if (lastTwo < 11 || lastTwo > 14) {
    if (last === 1) word = 'коллега'
    else if (last >= 2 && last <= 4) word = 'коллеги'
  }
  if (threshold >= 10) return `${threshold}+ ${word}`
  return `${threshold} ${word}`
}

export const referralRewards: ReferralReward[] = [
  {
    threshold: 1,
    label: '1 коллега',
    title: '2-я машина бесплатно',
    description: 'Навсегда',
  },
  {
    threshold: 2,
    label: '2 коллеги',
    title: 'Месяц за 199 ₽',
    description: 'На следующий тарифный период',
  },
  {
    threshold: 3,
    label: '3 коллеги',
    title: 'Месяц за 125 ₽',
    description: '+10 отслеживаний',
  },
  {
    threshold: 5,
    label: '5 коллег',
    title: 'Месяц бесплатно',
    description: '+30 отслеживаний',
  },
  {
    threshold: 10,
    label: '10+ коллег',
    title: 'Амбассадор Лупы',
    description: 'Персональный бонус',
  },
]

export function createReferralProgramState(
  activeReferralsCount = 0,
  referralLink = REFERRAL_PROGRAM_LINK,
  extra?: Partial<Pick<ReferralProgramState, 'bonusSlots' | 'trackingCredits' | 'coupons' | 'tiers'>>,
): ReferralProgramState {
  return {
    referralLink,
    activeReferralsCount,
    bonusSlots: extra?.bonusSlots ?? 0,
    trackingCredits: extra?.trackingCredits ?? 0,
    coupons: extra?.coupons ?? [],
    tiers: extra?.tiers ?? [],
  }
}

export const REFERRAL_PROGRAM_FALLBACK = createReferralProgramState()
